module.exports = __webpack_public_path__ + "static/media/google-play-badge-300x89.805daa17.png";